import { Record } from 'immutable';

const RewardsRecord = Record({
  completedClasses: undefined,
  totalClasses: undefined,
  classesCompletedPercent: undefined,
  completedHomeworks: undefined,
  totalHomeworks: undefined,
  homeworksCompletedPercent: undefined,
  completedWords: undefined,
  totalWords: undefined,
  wordsCompletedPercent: undefined,
  completedReaders: undefined,
  totalReaders: undefined,
  readersCompletedPercent: undefined,
  completedUnitQuiz: undefined,
  totalUnitQuiz: undefined,
  unitQuizCompletedPercent: undefined,
});

class Rewards extends RewardsRecord { }

Rewards.create = (data) => new Rewards(data);

export default Rewards;



// WEBPACK FOOTER //
// ./data/GroupPerformance/Rewards/model.js